import { UserOptionLabel, ViperSelect } from "@/components";
import { mergeUsers } from "@/components/ProjectRoleEditor/helper";
import { IUser } from "@/interfaces";
import { useSuggestUsersQuery } from "@/services";
import { Modal, Select } from "antd";
import { bool, func } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const { Option } = Select;

interface IProps {
  onOkClicked: (selectedUsers: IUser[]) => void;
  isDialogOpen: boolean;
  toggleDialog: () => void;
}

export const AddUserDialog = ({
  onOkClicked,
  isDialogOpen,
  toggleDialog,
}: IProps) => {
  const intl = useIntl();

  const [query, setQuery] = useState<string>("");
  const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);

  const { data: userSuggestions, isFetching: fetchingSuggestions } =
    useSuggestUsersQuery(
      { query },
      {
        skip: !query,
      }
    );

  const handleUsersSuggestionSelected = (
    selectedSuggestions: string[]
  ): void => {
    setSelectedUsers((value) =>
      mergeUsers(value, selectedSuggestions, userSuggestions)
    );
  };

  const handleClose = (): void => {
    setSelectedUsers([]);
    toggleDialog();
  };

  const okClicked = (): void => {
    if (selectedUsers.length) {
      onOkClicked(selectedUsers);
    }

    handleClose();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: "projectRoles.selectUsers" })}
      open={isDialogOpen}
      onOk={okClicked}
      onCancel={handleClose}
    >
      <ViperSelect
        onChange={handleUsersSuggestionSelected}
        optionLabelProp="label"
        customOptions={userSuggestions?.map(
          ({ document: { id, displayName, department, email, jobTitle } }) => (
            <Option key={id} label={displayName}>
              <UserOptionLabel
                displayName={displayName}
                department={department}
                email={email}
                jobTitle={jobTitle}
              />
            </Option>
          )
        )}
        loading={fetchingSuggestions}
        value={selectedUsers.map(({ id }) => id)}
        onFetchSuggestions={(searchTerm): void => {
          setQuery(searchTerm);
        }}
        data-test-id="add-users-dialog-users-add"
        allowMultipleSelections
      />
    </Modal>
  );
};

AddUserDialog.propTypes = {
  onOkClicked: func.isRequired,
  isDialogOpen: bool.isRequired,
  toggleDialog: func.isRequired,
};
